// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zones_zones__khnVA {
  height: calc(90vh - 170px);
  overflow: auto;
  display: flex; }
  .zones_zones__right__fYpK\\+ {
    height: auto;
    width: 380px;
    min-width: 380px;
    max-width: 380px;
    border-bottom: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    display: flex;
    flex-direction: column;
    padding: 20px;
    padding-right: 0; }
  .zones_zones__header__hbP2Q {
    display: flex;
    justify-content: space-between;
    color: #9e9e9e;
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    padding: 0 0 8px 0;
    background-color: #ffffff; }
    .zones_zones__header__hbP2Q .zones_add__65Rba {
      color: #fe6100;
      cursor: pointer;
      transition: all 0.4s;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px; }
      .zones_zones__header__hbP2Q .zones_add__65Rba:hover {
        color: #e55700; }
    .zones_zones__header__hbP2Q .zones_added__gewtw {
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      pointer-events: none;
      color: #9e9e9e; }

.zones_list__0kAFS {
  height: 100%;
  overflow: auto; }

.zones_item__lcBpy {
  width: 100%;
  padding-right: 20px; }
  .zones_item__edit__IluBh {
    padding: 18px 10px;
    background: #f5f5f5; }
  .zones_item__footer__IheZx {
    margin-top: 10px;
    display: flex;
    justify-content: space-between; }
    .zones_item__footer_control__u0z-O {
      display: flex;
      gap: 20px; }
  .zones_item__input__O8tXw {
    height: 40px;
    width: 100%;
    border: 1px solid var(--LowEmphasis);
    border-radius: 4px;
    padding: 8px 16px;
    margin-bottom: 30px; }
    .zones_item__input__O8tXw:focus {
      border-color: #212121;
      outline: none; }
  .zones_item__combobox__VKEYD {
    margin-bottom: 30px;
    width: 100%; }
  .zones_item__label__SA0cB {
    margin-bottom: 30px; }
  .zones_item__delete__kUei0 {
    background: #e00606;
    transition: all 0.4s; }
    .zones_item__delete__kUei0:hover {
      background: #fe6100; }
  .zones_item__description__6H9FG {
    color: #666666; }

.zones_zona__03A4C {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 100%;
  width: 100%; }
  .zones_zona__left__xwufT {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    max-width: calc(100% - 20px);
    width: calc(100% - 20px); }
  .zones_zona__name__LaX\\+5 {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }
  .zones_zona__workplace__eP3IL {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #666666;
    white-space: nowrap;
    max-width: calc(100% - 20px);
    width: calc(100% - 20px);
    overflow: hidden; }
  .zones_zona__right__kXGAe {
    width: 20%;
    cursor: pointer;
    text-align: right; }
  .zones_zona__03A4C .zones_rotate__4\\+RNL {
    transform: rotate(180deg); }

.zones_creating__pbBco {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 44px; }
  .zones_creating__pbBco p {
    text-align: center;
    width: 320px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }

.zones_preloader__AfU-7 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9000;
  background-color: rgba(255, 255, 255, 0.7); }

.zones_zonesSwitcher__x87gt {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 8px; }
`, "",{"version":3,"sources":["webpack://./src/pages/camera/modal/zones/zones.module.scss"],"names":[],"mappings":"AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,aAAa,EAAA;EACb;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB,EAAA;EAElB;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB,EAAA;IAR1B;MAUG,cAAc;MACd,eAAe;MACf,oBAAoB;MACpB,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;MAfpB;QAiBK,cAAc,EAAA;IAjBnB;MAqBG,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,oBAAoB;MACpB,cAAc,EAAA;;AAIpB;EACE,YAAY;EACZ,cAAc,EAAA;;AAEhB;EACE,WAAW;EACX,mBAAmB,EAAA;EACnB;IACE,kBAAkB;IAClB,mBAAmB,EAAA;EAErB;IACE,gBAAgB;IAChB,aAAa;IACb,8BAA8B,EAAA;IAC9B;MACE,aAAa;MACb,SAAS,EAAA;EAGb;IACE,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB,EAAA;IANpB;MAQG,qBAAqB;MACrB,aAAa,EAAA;EAGjB;IACE,mBAAmB;IACnB,WAAW,EAAA;EAEb;IACE,mBAAmB,EAAA;EAErB;IACE,mBAAmB;IACnB,oBAAoB,EAAA;IAFrB;MAIG,mBAAmB,EAAA;EAGvB;IACE,cAAc,EAAA;;AAGlB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EAEnB,eAAe;EACf,WAAW,EAAA;EACX;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,wBAAwB,EAAA;EAE1B;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAEnB;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB,EAAA;EAElB;IACE,UAAU;IACV,eAAe;IACf,iBAAiB,EAAA;EAhCrB;IAmCI,yBAAyB,EAAA;;AAI7B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS,EAAA;EAPX;IASI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;AAIrB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,0CAA0C,EAAA;;AAG5C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW,EAAA","sourcesContent":["@import '../../../../styles/media.scss';\n@import '../../../../styles/fonts.scss';\n.zones {\n  height: calc(90vh - 170px);\n  overflow: auto;\n  display: flex;\n  &__right {\n    height: auto;\n    width: 380px;\n    min-width: 380px;\n    max-width: 380px;\n    border-bottom: 1px solid #e0e0e0;\n    border-left: 1px solid #e0e0e0;\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    padding-right: 0;\n  }\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    color: #9e9e9e;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 150%;\n    padding: 0 0 8px 0;\n    background-color: #ffffff;\n    .add {\n      color: #fe6100;\n      cursor: pointer;\n      transition: all 0.4s;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 24px;\n      &:hover {\n        color: #e55700;\n      }\n    }\n    .added {\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 24px;\n      pointer-events: none;\n      color: #9e9e9e;\n    }\n  }\n}\n.list {\n  height: 100%;\n  overflow: auto;\n}\n.item {\n  width: 100%;\n  padding-right: 20px;\n  &__edit {\n    padding: 18px 10px;\n    background: #f5f5f5;\n  }\n  &__footer {\n    margin-top: 10px;\n    display: flex;\n    justify-content: space-between;\n    &_control {\n      display: flex;\n      gap: 20px;\n    }\n  }\n  &__input {\n    height: 40px;\n    width: 100%;\n    border: 1px solid var(--LowEmphasis);\n    border-radius: 4px;\n    padding: 8px 16px;\n    margin-bottom: 30px;\n    &:focus {\n      border-color: #212121;\n      outline: none;\n    }\n  }\n  &__combobox {\n    margin-bottom: 30px;\n    width: 100%;\n  }\n  &__label {\n    margin-bottom: 30px;\n  }\n  &__delete {\n    background: #e00606;\n    transition: all 0.4s;\n    &:hover {\n      background: #fe6100;\n    }\n  }\n  &__description {\n    color: #666666;\n  }\n}\n.zona {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  // height: 50px;\n  max-width: 100%;\n  width: 100%;\n  &__left {\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    max-width: calc(100% - 20px);\n    width: calc(100% - 20px);\n  }\n  &__name {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n  }\n  &__workplace {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: #666666;\n    white-space: nowrap;\n    max-width: calc(100% - 20px);\n    width: calc(100% - 20px);\n    overflow: hidden;\n  }\n  &__right {\n    width: 20%;\n    cursor: pointer;\n    text-align: right;\n  }\n  .rotate {\n    transform: rotate(180deg);\n  }\n}\n\n.creating {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  gap: 44px;\n  p {\n    text-align: center;\n    width: 320px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n\n.preloader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9000;\n  background-color: rgba(255, 255, 255, 0.7);\n}\n\n.zonesSwitcher{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"zones": `zones_zones__khnVA`,
	"zones__right": `zones_zones__right__fYpK+`,
	"zones__header": `zones_zones__header__hbP2Q`,
	"add": `zones_add__65Rba`,
	"added": `zones_added__gewtw`,
	"list": `zones_list__0kAFS`,
	"item": `zones_item__lcBpy`,
	"item__edit": `zones_item__edit__IluBh`,
	"item__footer": `zones_item__footer__IheZx`,
	"item__footer_control": `zones_item__footer_control__u0z-O`,
	"item__input": `zones_item__input__O8tXw`,
	"item__combobox": `zones_item__combobox__VKEYD`,
	"item__label": `zones_item__label__SA0cB`,
	"item__delete": `zones_item__delete__kUei0`,
	"item__description": `zones_item__description__6H9FG`,
	"zona": `zones_zona__03A4C`,
	"zona__left": `zones_zona__left__xwufT`,
	"zona__name": `zones_zona__name__LaX+5`,
	"zona__workplace": `zones_zona__workplace__eP3IL`,
	"zona__right": `zones_zona__right__kXGAe`,
	"rotate": `zones_rotate__4+RNL`,
	"creating": `zones_creating__pbBco`,
	"preloader": `zones_preloader__AfU-7`,
	"zonesSwitcher": `zones_zonesSwitcher__x87gt`
};
export default ___CSS_LOADER_EXPORT___;
